const mapperRangesToAPI = form => {
    const { title, headlight, target, multiplier } = form
    const requiredFields = {
        title,
        multiplier,
        headlight_id: headlight.value,
    }
    return target ? { ...requiredFields, target } : { ...requiredFields }
}

export { mapperRangesToAPI }
